export enum LeftActivePageEnum {
  Rides = "Rides",
  Bookings = "Bookings",
  LiveMap = "LiveMap",
  Reports = "Reports",
  Courses = "Courses",
  Passengers = "Passengers",
  ProduceButtons = "ProduceButtons",
  Feedbacks = "Feedbacks",
  Settings = "Settings",
  Home = "Home",
}
